<script>
/**
 * Carcasa del preview móvil (iframe dentro del teléfono).
 * Sync de config vía postMessage (sin remount en cada cambio).
 */
export default {
  name: "HomeMobilePreviewShell",
  props: {
    src: { type: String, required: true },
  },
  methods: {
    getFrameWindow() {
      const el = this.$refs.frame;
      return el && el.contentWindow ? el.contentWindow : null;
    },
    onFrameLoad() {
      this.$emit("frame-load");
    },
  },
};
</script>

<template>
  <div class="storefront-home__device storefront-home__device--phone">
    <div class="storefront-home__device-notch" aria-hidden="true" />
    <div class="storefront-home__device-screen">
      <iframe
        ref="frame"
        class="storefront-home__device-iframe"
        :src="src"
        title="Vista móvil"
        loading="eager"
        @load="onFrameLoad"
      />
    </div>
    <p class="storefront-home__touch-hint">
      Arrastra con el mouse (círculo = dedo) para deslizar banners y colecciones.
    </p>
  </div>
</template>

<style lang="scss">
/* Estilos del stage en modo preview móvil (solo con este chunk). */
.storefront-home--viewport-mobile {
  width: 100%;
  min-height: 100vh;
  background:
    radial-gradient(ellipse at 30% 0%, rgba(0, 0, 0, 0.06), transparent 55%),
    linear-gradient(165deg, #ececec 0%, #d6d6d6 100%);

  .storefront-home__stage {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 1.25rem 1rem 7rem;
    padding-right: calc(1rem + var(--storefront-config-panel-offset, 0px));
    min-height: 100vh;
    width: 100%;
    background: transparent;
    box-sizing: border-box;
  }

  .storefront-home__device--phone {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 420px;
    max-width: calc(100vw - 2.5rem);
    height: min(760px, calc(100vh - 9rem));
    max-height: min(760px, calc(100vh - 9rem));
    flex: 0 0 auto;
    background: #1a1a1a;
    border-radius: 36px;
    padding: 14px;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow:
      0 0 0 1px rgba(255, 255, 255, 0.08) inset,
      0 24px 48px rgba(0, 0, 0, 0.28);
  }

  .storefront-home__device-notch {
    position: absolute;
    top: 8px;
    left: 50%;
    z-index: 3;
    width: 88px;
    height: 18px;
    transform: translateX(-50%);
    background: #1a1a1a;
    border-radius: 12px;
    pointer-events: none;
  }

  .storefront-home__device-screen {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 26px;
    overflow: hidden;
    isolation: isolate;
  }

  .storefront-home__device-iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    background: #fff;
    border-radius: inherit;
    touch-action: manipulation;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
  }

  .storefront-home__touch-hint {
    margin: 0.55rem 0 0;
    padding: 0 0.35rem;
    font-size: 0.7rem;
    line-height: 1.35;
    color: #6c757d;
    text-align: center;
  }
}
</style>
